/**
 * Digital Contents Service
 * Handles all digital content-related API calls
 */

import network from '../../Network/NetworkManager';

const APPURL = require('../../Constants/URLConstants');

/**
 * Get digital contents for a listing
 * @param {number} listingId - Listing ID
 * @returns {Promise<object>} - Response with digital contents array
 */
export const getDigitalContents = async (listingId) => {
  try {
    const response = await network.networkCall(
      `v1/listings/${listingId}/digital_contents`,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching digital contents:', error);
    throw error;
  }
};

/**
 * Create digital content for a listing
 * @param {number} listingId - Listing ID
 * @param {object} digitalContentData - Digital content data
 * @returns {Promise<object>} - Response with created digital content
 */
export const createDigitalContent = async (listingId, digitalContentData) => {
  try {
    const response = await network.networkCall(
      `v1/listings/${listingId}/digital_contents`,
      'POST',
      JSON.stringify({ digital_content: digitalContentData }),
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error creating digital content:', error);
    throw error;
  }
};

/**
 * Update digital content
 * @param {number} listingId - Listing ID
 * @param {number} contentId - Digital content ID
 * @param {object} digitalContentData - Updated digital content data
 * @returns {Promise<object>} - Response with updated digital content
 */
export const updateDigitalContent = async (
  listingId,
  contentId,
  digitalContentData
) => {
  try {
    const response = await network.networkCall(
      `v1/listings/${listingId}/digital_contents/${contentId}`,
      'PATCH',
      JSON.stringify({ digital_content: digitalContentData }),
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error updating digital content:', error);
    throw error;
  }
};

/**
 * Delete digital content
 * @param {number} listingId - Listing ID
 * @param {number} contentId - Digital content ID
 * @returns {Promise<object>} - Response
 */
export const deleteDigitalContent = async (listingId, contentId) => {
  try {
    const response = await network.networkCall(
      `v1/listings/${listingId}/digital_contents/${contentId}`,
      'DELETE',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error deleting digital content:', error);
    throw error;
  }
};

/**
 * Get single digital content by ID
 * @param {number} listingId - Listing ID
 * @param {number} contentId - Digital content ID
 * @returns {Promise<object>} - Response with digital content data
 */
export const getDigitalContentById = async (listingId, contentId) => {
  try {
    const response = await network.networkCall(
      `v1/listings/${listingId}/digital_contents/${contentId}`,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching digital content:', error);
    throw error;
  }
};
